export default __webpack_public_path__ + "static/media/Thaumaturge's Bracers of the Emperor's Favor.85863023.jpg";